import request from "@/utils/auth-net";
import request2 from "@/utils/request";
//通过code获取accessToken
export function getAccessTokenByCodeApi(code) {
  return request({
    url: "enterpriseAuth/getAccessToken?code=" + code,
    // url: "https://mock.apipost.net/mock/341e6a67700b000/getAccessToken?apipost_id=19753398f07003",
    method: "get"
  });
}

// 通过accessToken获取用户信息
export function getUserInfoApi(accessToken) {
  return request({
    url: "enterpriseAuth/getEnterpriseInfo?accessToken=" + accessToken,
    // url: "https://mock.apipost.net/mock/341e6a67700b000/getEnterpriseInfo?apipost_id=1977ccd9f0700f",
    method: "get"
  });
}

// 通过accessToken获取的用户信息获取userId
export function getUserIdApi(userInfo) {
  return request2({
    url: "cgx-user/loginAuth",
    method: "post",
    data: userInfo
  });
}
